import Modal from "../../../shared/Modal.tsx";
import { useActivity } from "../../../../api/activitystreams.ts";
import ActivityComposer from "../../ActivityComposer.tsx";
import PageLoading from "../../../shared/PageLoading.tsx";
import useActivitystreamsFromSlugs from "../../../shared/hooks/useActivitystreamsFromSlugs.ts";
import { AppointmentObject, ObjectWithContent } from "@/@types/activities.ts";
import { omit } from "lodash";

type EditActivityFormArgs = {
  activityId: string;
  close: () => void;
};

export default function EditActivityForm({
  activityId,
  close,
}: EditActivityFormArgs) {
  const { data: activity, isLoading } = useActivity(activityId, { edit: true });
  const streamsFromActivity = useActivitystreamsFromSlugs({
    slugs: activity?.activitystream_slugs || [],
    includeSubscriberCount: true,
  });

  return (
    <Modal
      title={I18n.t(
        activity?.object.type === "appointment"
          ? "activitystreams.change_visibility"
          : "js.composer.edit_activity",
      )}
      onClose={close}
    >
      {isLoading ? (
        <PageLoading />
      ) : (
        activity && (
          <ActivityComposer
            activity={{
              ...omit(activity, "object"),
              activitystreams: streamsFromActivity,
              object: activity.object as ObjectWithContent | AppointmentObject,
            }}
            closeModal={close}
          />
        )
      )}
    </Modal>
  );
}
